import React from "react";

export default function BrowserFrame({ url = "akomoda.app", title, children, dark = false, lg = false, className = "" }) {
  const frame = lg ? "browser-frame-lg" : "browser-frame";
  return (
    <div className={`${frame} ${dark ? "bg-[#0F172A] border-white/10" : ""} ${className}`} data-testid="browser-frame">
      <div className={`browser-chrome ${dark ? "border-white/10 bg-[#0B1220]" : ""}`}>
        <div className="flex items-center gap-1.5">
          <span className="browser-dot bg-[#FEC4C4]" />
          <span className="browser-dot bg-[#FEE9B2]" />
          <span className="browser-dot bg-[#C6F0CE]" />
        </div>
        <div className={`flex flex-1 items-center justify-between gap-3 rounded-md border px-3 py-1 ${dark ? "border-white/10 bg-white/[0.04] text-white/60" : "border-[#E2E8F0] bg-white text-[#64748B]"}`}>
          <div className="flex items-center gap-2 text-[11px]">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <rect x="3" y="11" width="18" height="11" rx="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <span className="font-mono">{url}</span>
          </div>
          {title && <span className="text-[10px] font-mono">{title}</span>}
        </div>
      </div>
      <div className="relative">{children}</div>
    </div>
  );
}
